import classNames from 'classnames';
import { ReactNode } from 'react';

type ChipsProps = {
  icon?: ReactNode;
  text: string;
  className?: string;
  textClassName?: string;
  clickable?: boolean;
  onClick?: () => void;
};

const Chips = ({
  text,
  icon,
  className,
  textClassName,
  clickable,
  onClick,
}: ChipsProps) => {
  return (
    <div
      className={classNames(
        'flex items-center gap-x-1 px-2 py-1 rounded-full text-nowrap',
        clickable && 'cursor-pointer',
        className,
      )}
      onClick={clickable ? onClick : undefined}
    >
      {icon ? icon : <></>}

      <span className={classNames('text-xs', textClassName)}>{text}</span>
    </div>
  );
};

export default Chips;
